import { supabase } from './supabase';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function request(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${res.status})`);
  }

  return res.status === 204 ? null : res.json();
}

export const api = {
  me: () => request('/me'),

  profile: {
    update: (updates) =>
      request('/me', { method: 'PATCH', body: JSON.stringify(updates) }),
  },

  checkins: {
    history: (days = 7) => request(`/checkins/history?days=${days}`),
    log: (mood, note, checked_in_on) =>
      request('/checkins', { method: 'POST', body: JSON.stringify({ mood, note, checked_in_on }) }),
    update: (mood, note, checked_in_on) =>
      request('/checkins/today', { method: 'PATCH', body: JSON.stringify({ mood, note, checked_in_on }) }),
    alert: (anomaly_type) =>
      request('/checkins/alert', { method: 'POST', body: JSON.stringify({ anomaly_type }) }),
    deleteAll: () => request('/checkins', { method: 'DELETE' }),
  },

  troop: {
    // Returns { pinned: [...], members: [...] }
    list: () => request('/troop'),
    reach: (friendId, message) =>
      request(`/troop/${friendId}/reach`, { method: 'POST', body: JSON.stringify({ message: message || null }) }),
    reachInbox: () => request('/troop/reaches/inbox'),
    ackReach: (id, reply) =>
      request(`/troop/reaches/${id}/ack`, { method: 'POST', body: JSON.stringify({ reply: reply || null }) }),
    pending: () => request('/troop/pending'),
    invite: (email) =>
      request('/troop/invite', { method: 'POST', body: JSON.stringify({ email }) }),
    inviteLink: () => request('/troop/invite-link'),
    redeem: (code) =>
      request('/troop/redeem', { method: 'POST', body: JSON.stringify({ code }) }),
    accept: (friendId) =>
      request(`/troop/${friendId}/accept`, { method: 'PATCH' }),
    pin: (userId) =>
      request(`/troop/${userId}/pin`, { method: 'POST' }),
    unpin: (userId) =>
      request(`/troop/${userId}/pin`, { method: 'DELETE' }),
    nominate: (userId) =>
      request(`/troop/${userId}/nominate`, { method: 'POST' }),
    denominate: (userId) =>
      request(`/troop/${userId}/nominate`, { method: 'DELETE' }),
  },

  reflections: {
    list: () => request('/reflections'),
    save: (mood, anomaly_type, body, prompt) =>
      request('/reflections', { method: 'POST', body: JSON.stringify({ mood, anomaly_type, body, prompt: prompt || null }) }),
    deleteAll: () => request('/reflections', { method: 'DELETE' }),
  },

  settings: {
    get: () => request('/settings'),
    update: (updates) =>
      request('/settings', { method: 'PATCH', body: JSON.stringify(updates) }),
  },

  push: {
    vapidPublicKey: () => request('/push/vapid-public-key'),
    subscribe: (subscription) =>
      request('/push/subscribe', { method: 'POST', body: JSON.stringify(subscription) }),
    unsubscribe: (endpoint) =>
      request('/push/unsubscribe', { method: 'POST', body: JSON.stringify({ endpoint }) }),
    test: () => request('/push/test', { method: 'POST' }),
  },
};
